// extracted by mini-css-extract-plugin
export default {"errorContent":"ErrorModal_errorContent__LE6uz","errorTitle":"ErrorModal_errorTitle__61OJu","closeButton":"ErrorModal_closeButton__wSdXO"};